<template>
	<div>
		<reports-list :is-admin="loggedInEmployee.isAdmin" :reports="availableReports" />

		<v-footer color app height="55">
			<v-spacer></v-spacer>
			<footer-back-btn @click="cancel" />
		</v-footer>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import ReportsList from '@/components/reports/ReportsList';

	export default {
		data() {
			return {};
		},
		components: {
			ReportsList
		},
		computed: {
			...mapGetters({
				loggedInEmployee: 'loggedInEmployee',
				availableReports: 'reports/availableReports'
			})
		},
		created() {
			this.isLoading = true;
			this.$store.dispatch('setPageTitle', 'Reports');
		},
		methods: {
			cancel() {
				window.history.back();
			}
		}
	};
</script>

<style></style>
